/*
 * New Lead Profile
 */
import React, { useState } from "react";
import { withSnackbar } from "notistack";

import TxtRow from "components/Custom/TxtRow";
import Btn from "components/Custom/Btn";
import RadioBtn from "components/Custom/RadioBtn";

import { LABELS, SUCCESS } from "common/lables";
import { COLORS } from "common/colors";
import { CRM_LEAD_STATUS, FORMATS, NOTIFY } from "common/config";
import { DateFunctions } from "common/datefunctions";
import { COMMON_JS } from "common/scripts";
import { CRM_APIs } from "apihandlers/crm";

interface defaultProps {
  setManageNewDialog;
  selectedRow;
}

const NewDealer = (props: any) => {
  const { setManageNewDialog, selectedRow, onClose } = props;
  const [isSubmit, setIsSubmit] = useState(false);

  const saveRecord = async () => {
    try {
      // Agency Details
      const firmName = (
        document.getElementById("firmName") as HTMLInputElement
      ).value.trim();
      const city = (
        document.getElementById("city") as HTMLInputElement
      ).value.trim();
      const taluka = (
        document.getElementById("taluka") as HTMLInputElement
      ).value.trim();
      const state = (
        document.getElementById("state") as HTMLInputElement
      ).value.trim();
      const district = (
        document.getElementById("district") as HTMLInputElement
      ).value.trim();
      const zone = (
        document.getElementById("zone") as HTMLInputElement
      ).value.trim();
      const population = (
        document.getElementById("population") as HTMLInputElement
      ).value.trim();
      let type = document.querySelector(
        'input[name="Status"]:checked'
      ) as HTMLInputElement;
      const Status = type ? type.value : "";

      //Contact Person
      const fullName = (
        document.getElementById("fullName") as HTMLInputElement
      ).value.trim();
      const mobileNo = (
        document.getElementById("mobileNo") as HTMLInputElement
      ).value.trim();

      //Phy Godown Verification
      let phyGodown = document.querySelector(
        'input[name="GodownStatus"]:checked'
      ) as HTMLInputElement;
      const GodownStatus = phyGodown ? phyGodown.value : "";
      let phyOwner = document.querySelector(
        'input[name="OwnerStatus"]:checked'
      ) as HTMLInputElement;
      const OwnerStatus = phyOwner ? phyOwner.value : "";
      const godownSize = (
        document.getElementById("godownSize") as HTMLInputElement
      ).value.trim();

      // Logistic Verification
      let phyVehical = document.querySelector(
        'input[name="VehicalStatus"]:checked'
      ) as HTMLInputElement;
      const VehicalStatus = phyVehical ? phyVehical.value : "";
      let phyVehicalOwner = document.querySelector(
        'input[name="VehicleOwnerStatus"]:checked'
      ) as HTMLInputElement;
      const VehicleOwnerStatus = phyVehicalOwner ? phyVehicalOwner.value : "";
      let phyVehicalType = document.querySelector(
        'input[name="VehicleTypeStatus"]:checked'
      ) as HTMLInputElement;
      const VehicleTypeStatus = phyVehicalType ? phyVehicalType.value : "";
      const noOfVehicle = (
        document.getElementById("noOfVehicle") as HTMLInputElement
      ).value.trim();
      const packBody = (
        document.getElementById("packBody") as HTMLInputElement
      ).value.trim();

      //Access Verification
      let access = document.querySelector(
        'input[name="AccessStatus"]:checked'
      ) as HTMLInputElement;
      const AccessStatus = access ? access.value : "";
      const accessReason = (
        document.getElementById("accessReason") as HTMLInputElement
      ).value.trim();

      //Tech Verification
      let tech = document.querySelector(
        'input[name="TechStatus"]:checked'
      ) as HTMLInputElement;
      const TechStatus = tech ? tech.value : "";
      let online = document.querySelector(
        'input[name="OnlineStatus"]:checked'
      ) as HTMLInputElement;
      const OnlineStatus = online ? online.value : "";
      const onlineDate = (
        document.getElementById("onlineDate") as HTMLInputElement
      ).value.trim();
      let weekly = document.querySelector(
        'input[name="WeeklyStatus"]:checked'
      ) as HTMLInputElement;
      const WeeklyStatus = weekly ? weekly.value : "";

      //Work Mode Verification
      let work = document.querySelector(
        'input[name="WorkModeStatus"]:checked'
      ) as HTMLInputElement;
      const WorkModeStatus = work ? work.value : "";
      const workCondition = (
        document.getElementById("workCondition") as HTMLInputElement
      ).value.trim();
      const agencyName = (
        document.getElementById("agencyName") as HTMLInputElement
      ).value.trim();

      //Finance Verification
      let finance = document.querySelector(
        'input[name="FinanceStatus"]:checked'
      ) as HTMLInputElement;
      const FinanceStatus = finance ? finance.value : "";
      const investCapacity = (
        document.getElementById("investCapacity") as HTMLInputElement
      ).value.trim();
      const familyMembers = (
        document.getElementById("familyMembers") as HTMLInputElement
      ).value.trim();
      let business = document.querySelector(
        'input[name="BusinessStatus"]:checked'
      ) as HTMLInputElement;
      const BusinessStatus = business ? business.value : "";
      const name = (
        document.getElementById("name") as HTMLInputElement
      ).value.trim();
      const businessDesignation = (
        document.getElementById("businessDesignation") as HTMLInputElement
      ).value.trim();
      const monthly = (
        document.getElementById("monthly") as HTMLInputElement
      ).value.trim();
      const yearly = (
        document.getElementById("yearly") as HTMLInputElement
      ).value.trim();

      // First Order Detail
      const firstOrderName = (
        document.getElementById("firstOrderName") as HTMLInputElement
      ).value.trim();
      const firstOrderDate = (
        document.getElementById("firstOrderDate") as HTMLInputElement
      ).value.trim();
      const firstOrderDesignantion = (
        document.getElementById("firstOrderDesignantion") as HTMLInputElement
      ).value.trim();

      const argsAgencyDetails = {
        firmName,
        city,
        zone,
        state,
        district,
        taluk: taluka,
        population,
        Status,
      };
      const argsContactPerson = {
        fullName,
        mob1: mobileNo,
      };
      const argsPhysicalGodown = {
        GodownStatus,
        OwnerStatus,
        godownSize,
      };
      const argsLogistics = {
        VehicalStatus,
        VehicleOwnerStatus,
        VehicleTypeStatus,
        noOfVehicle,
        packBody,
      };
      const argsAccess = {
        AccessStatus,
        accessReason,
      };
      const argsTech = {
        TechStatus,
        OnlineStatus,
        onlineDate,
        WeeklyStatus,
      };
      const argsWorkMode = {
        WorkModeStatus,
        workCondition,
        agencyName,
      };
      const argsFinance = {
        FinanceStatus,
        investCapacity,
        familyMembers,
        BusinessStatus,
        name,
        businessDesignation,
        monthly,
        yearly,
      };
      const argsFirstOrder = {
        firstOrderName,
        firstOrderDate,
        firstOrderDesignantion,
      };
      const args = {
        crmLeadId: selectedRow.id,
        crmLeadStatus: CRM_LEAD_STATUS.STORE_VISIT,
        crmLeadName: selectedRow.crmLeadName,
        activeStatus: selectedRow.activeStatus,
        currentDetails: {
          ...JSON.parse(selectedRow.currentDetails),
          ...argsAgencyDetails,
        },
        personalDetails: {
          ...JSON.parse(selectedRow.personalDetails),
          ...argsContactPerson,
        },
        firstOrderDetails: argsFirstOrder,
        logisticsVerificationDetails: argsLogistics,
        accessVerificationDetails: argsAccess,
        godownVerificationDetails: argsPhysicalGodown,
        techVerificationDetails: argsTech,
        workModeVerificationDetails: argsWorkMode,
        financeVerificationDetails: argsFinance,
      };
      setIsSubmit(true);
      const res: any = await CRM_APIs.manageCrmLeadProfile(args);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        onClose();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
      }
      setIsSubmit(false);
      console.log("saveRecord: ", args, res);
    } catch (error) {
      setIsSubmit(false);
      console.log("saveRecord: error:", error);
    }
  };

  return (
    <>
      <div
        className="formWrapper"
        style={{
          height: window.innerHeight * 0.7,
          overflow: "auto",
          paddingRight: "1rem",
        }}
      >
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.AGENCY_DETAILS}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"firmName"}
                type={"text"}
                label={LABELS.FIRM_NAME}
                //required={true}
                defaultValue={selectedRow.firmName}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"city"}
                type={"text"}
                label={LABELS.CITY}
                // required={true}
                defaultValue={selectedRow.city}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"taluka"}
                type={"text"}
                label={LABELS.TALUKA}
                // required={true}
                defaultValue={selectedRow.taluka}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"district"}
                type={"text"}
                label={LABELS.DIST}
                //required={true}
                defaultValue={selectedRow.district}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"zone"}
                type={"text"}
                label={LABELS.ZONE}
                //required={true}
                defaultValue={selectedRow.zone}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"population"}
                type={"text"}
                label={LABELS.POPULATION}
                //required={true}
                defaultValue={selectedRow.population}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"state"}
                type={"text"}
                label={LABELS.STATE}
                //required={true}
                defaultValue={selectedRow.state}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.STATUS}</label>
              <RadioBtn
                list={[
                  {
                    id: "Proprietor",
                    value: "Proprietor",
                    label: LABELS.PROPRIETOR,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === true
                      : true,
                    disabled: false,
                  },
                  {
                    id: "Partnership",
                    value: "Partnership",
                    label: LABELS.PARTNERSHIP,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === false
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"Status"}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.CONTACT_PERSON}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"fullName"}
                type={"text"}
                label={LABELS.FULL_NAME}
                //required={true}
                defaultValue={selectedRow.fullName}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"mobileNo"}
                type={"text"}
                label={LABELS.MOBILE_NUMBER}
                // required={true}
                defaultValue={selectedRow.mobileNo}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.PHY_GODOWN_VERIFICATION}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>{"Physical godown verification"}</label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.id
                      ? selectedRow.GodownStatus === true
                      : true,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.id
                      ? selectedRow.GodownStatus === false
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"GodownStatus"}
              />
            </div>
            <div className="formGroup width30">
              <label>{"Physical godown verification"}</label>
              <RadioBtn
                list={[
                  {
                    id: "own",
                    value: "own",
                    label: LABELS.OWN,
                    checked: selectedRow.id
                      ? selectedRow.OwnerStatus === true
                      : true,
                    disabled: false,
                  },
                  {
                    id: "rented",
                    value: "rented",
                    label: LABELS.RENTED,
                    checked: selectedRow.id
                      ? selectedRow.OwnerStatus === false
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"OwnerStatus"}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"godownSize"}
                type={"text"}
                label={LABELS.SIZE_OF_GODOWN}
                // required={true}
                defaultValue={selectedRow.godownSize}
                //disabled={isSubmit}
              />
            </div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.LOGISTICS_VERIFICATION}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>{"Physical vehicle verification"}</label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.id
                      ? selectedRow.VehicalStatus === true
                      : true,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.id
                      ? selectedRow.VehicalStatus === false
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"VehicalStatus"}
              />
            </div>
            <div className="formGroup width30">
              <label>{"Physical vehicle verification"}</label>
              <RadioBtn
                list={[
                  {
                    id: "own",
                    value: "own",
                    label: LABELS.OWN,
                    checked: selectedRow.id
                      ? selectedRow.VehicleOwnerStatus === true
                      : true,
                    disabled: false,
                  },
                  {
                    id: "rented",
                    value: "rented",
                    label: LABELS.RENTED,
                    checked: selectedRow.id
                      ? selectedRow.VehicleOwnerStatus === false
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"VehicleOwnerStatus"}
              />
            </div>
            <div className="formGroup width30">
              <label>{"Physical vehicle verification"}</label>
              <RadioBtn
                list={[
                  {
                    id: "old",
                    value: "old",
                    label: LABELS.OLD,
                    checked: selectedRow.id
                      ? selectedRow.VehicleTypeStatus === "old"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "new",
                    value: "new",
                    label: LABELS.NEW,
                    checked: selectedRow.id
                      ? selectedRow.VehicleTypeStatus === "new"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"VehicleTypeStatus"}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"noOfVehicle"}
                type={"text"}
                label={LABELS.NO_OF_VEHICLE}
                // required={true}
                defaultValue={selectedRow.noOfVehicle}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"packBody"}
                type={"text"}
                label={LABELS.PACK_BODY}
                // required={true}
                defaultValue={selectedRow.packBody}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{LABELS.ACCESS_VERIFICATION}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>
                {"Company / transport vehicle reachable to godown ?"}
              </label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.id
                      ? selectedRow.AccessStatus === "yes"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.id
                      ? selectedRow.AccessStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"AccessStatus"}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"accessReason"}
                type={"text"}
                label={
                  "If No, reason for the same (wire obstruction, water clogging etc)"
                }
                // required={true}
                defaultValue={selectedRow.accessReason}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{"Tech Verification"}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>{"Does he have Computer/PC or Laptop / Printer?"}</label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.id
                      ? selectedRow.TechStatus === "yes"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.id
                      ? selectedRow.TechStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"TechStatus"}
              />
            </div>
            <div className="formGroup width30">
              <label>
                {"Will he be able to work on our online order system? "}
              </label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.id
                      ? selectedRow.OnlineStatus === "yes"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.id
                      ? selectedRow.OnlineStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"OnlineStatus"}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"onlineDate"}
                type={"date"}
                label={
                  " If No, when he will be able to work on online order system"
                }
                // required={true}
                defaultValue={
                  selectedRow.onlineDate
                    ? DateFunctions.getFormatedDate(
                        selectedRow.onlineDate,

                        FORMATS.SQL_DATE,

                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",

                        "from",

                        FORMATS.SQL_DATE_ONLY
                      )
                }
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>
                {"weekly order schedule or bi-weekly order schedule?"}
              </label>
              <RadioBtn
                list={[
                  {
                    id: "Weekly",
                    value: "Weekly",
                    label: "Weekly",
                    checked: selectedRow.id
                      ? selectedRow.WeeklyStatus === "Weekly"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "Bi-Weekly",
                    value: "Bi-Weekly",
                    label: "Bi-Weekly",
                    checked: selectedRow.id
                      ? selectedRow.WeeklyStatus === "Bi-Weekly"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"WeeklyStatus"}
              />
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{"Work Mode Verification"}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>{"Will he work exclusively for GSL ?"}</label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.id
                      ? selectedRow.WorkModeStatus === "yes"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.id
                      ? selectedRow.WorkModeStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"WorkModeStatus"}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"workCondition"}
                type={"text"}
                label={
                  "If no, at what conditions he will convert to exclusive dealer?"
                }
                // required={true}
                defaultValue={selectedRow.workCondition}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"agencyName"}
                type={"text"}
                label={"Name of agency/Business/Products (Other than GSL)"}
                // required={true}
                defaultValue={selectedRow.agencyName}
                //disabled={isSubmit}
              />
            </div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{"Finance Verification"}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>{"Is he financially sound to do business or not ?"}</label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.id
                      ? selectedRow.FinanceStatus === "yes"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.id
                      ? selectedRow.FinanceStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"FinanceStatus"}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"investCapacity"}
                type={"text"}
                label={"Investment capacity (Working Capital) "}
                // required={true}
                defaultValue={selectedRow.investCapacity}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"familyMembers"}
                type={"text"}
                label={"How many family members will work in the business"}
                // required={true}
                defaultValue={selectedRow.familyMembers}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <label>
                {"Will he be dedicated person to handle the business  ?"}
              </label>
              <RadioBtn
                list={[
                  {
                    id: "yes",
                    value: "yes",
                    label: LABELS.YES,
                    checked: selectedRow.id
                      ? selectedRow.BusinessStatus === "yes"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "no",
                    value: "no",
                    label: LABELS.NO,
                    checked: selectedRow.id
                      ? selectedRow.BusinessStatus === "no"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"BusinessStatus"}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"name"}
                type={"text"}
                label={"Name"}
                // required={true}
                defaultValue={selectedRow.name}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"businessDesignation"}
                type={"text"}
                label={"Designation"}
                // required={true}
                defaultValue={selectedRow.businessDesignation}
                //disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"monthly"}
                type={"text"}
                label={"Other source of income Monthly"}
                // required={true}
                defaultValue={selectedRow.monthly}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"yearly"}
                type={"text"}
                label={"Other source of income Yearly"}
                // required={true}
                defaultValue={selectedRow.yearly}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30"></div>
          </div>
        </div>
        <div className="formGroupBox">
          <div className="formGroupTitle">
            <h4>{"First Order Detail"}</h4>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"firstOrderName"}
                type={"text"}
                label={"Name"}
                // required={true}
                defaultValue={selectedRow.firstOrderName}
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"firstOrderDate"}
                type={"date"}
                label={"Date"}
                // required={true}
                defaultValue={
                  selectedRow.firstOrderDate
                    ? DateFunctions.getFormatedDate(
                        selectedRow.firstOrderDate,

                        FORMATS.SQL_DATE,

                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",

                        "from",

                        FORMATS.SQL_DATE_ONLY
                      )
                }
                //disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"firstOrderDesignantion"}
                type={"text"}
                label={"Designation"}
                // required={true}
                defaultValue={selectedRow.firstOrderDesignantion}
                //disabled={isSubmit}
              />
            </div>
          </div>
        </div>
      </div>

      {/* BtmMenu */}
      <div className="formGroup submitBtnWrapper">
        <div className="width30 flexRowAround">
          <Btn text={LABELS.SAVE} loading={isSubmit} onClick={saveRecord} />
        </div>
      </div>
    </>
  );
};

export default withSnackbar(NewDealer);
